import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = 'nominas/percepciones-configuraciones-ipejal';
/**
 * GET IPEJAL Percepciones
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getIPEJALpercepcionesPag = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET IPEJAL Percepciones
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getIPEJALpercepciones = async () => {
  try {
    const response = await API.get(baseURI);
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET IPEJAL Percepciones
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getIPEJALpercepcion = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST IPEJAL Percepciones
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postIPEJALpercepcion = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH IPEJAL Percepciones
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchIPEJALpercepcion = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE IPEJAL Percepciones
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteIPEJALpercepcion = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR IPEJAL Percepciones
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarIPEJALpercepcion = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
